import React, { Fragment, useState } from 'react';
import cx from 'classnames';

import { Button, FAQs } from 'components';
import faqContent from "cms/content/faqs-faqs.yml";


const SectionFAQs = ({locale}) => {

  const [active, toggleFaq] = useState(0);

  if(!faqContent.enabled) return false;

  return (
    <Fragment>
      <div className='section-topics'>
        <p className='t-center mb-40'><b dangerouslySetInnerHTML={{ __html: faqContent.title }} /></p>
        <div className='topics-wrapper'>
          {faqContent.topics.map( (item, idx) => {
            return (
              <Button label={item['topic']} level='outline' onClick={() => toggleFaq(idx)} key={idx} />
            )
          })}
        </div>
      </div>

      {faqContent.topics.map( (item, idx) => (
        <FAQs key={idx} faqsData={item['faqs']} title={item['topic']} locale={locale} className={cx({ 'hide': active !== idx })} />
      ))}
    </Fragment>
  );
};

export default SectionFAQs;
